var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import withBranding from "@irati/brand/withBranding";
import { FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { determineDealThumbnailImage } from "@irati/deals/helpers/deals/appearance";
import { isDealUnavailable } from "@irati/deals/helpers/deals/isDealUnavailable";
import { COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS } from "@irati/deals/constants/dealType";
import isBoostedPerk from "@irati/deals/helpers/deals/isBoostedPerk";
import { RouterLink } from "@irati/ui/src/Link";
import Saving from "@irati-web/perks/src/components/Saving";
import getCurrency from "@irati/deals/helpers/deals/currency";
import { connect } from "@irati/store";
import Flex from "@irati/ui/src/Flex";
import { H5 } from "@irati/ui/src/Typography";
import BoostedSaving from "./BoostedSaving";
import UnavailableDeal from "./UnavailableDeal";
import { AvatarContainer, DealAvatar, Container, StyledBadge, StyledIconText, SavingWrapper, Col, SecondRow, StyledProximity, StyledRouterLink, EmptyWrapper } from "./styled/DealResult";
var DealResult = /** @class */ (function (_super) {
    __extends(DealResult, _super);
    function DealResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getWrapper = function () {
            var _a = _this.props, onClick = _a.onClick, shouldLinkToDealOnClick = _a.shouldLinkToDealOnClick, deal = _a.deal;
            var apps = _this.context.apps;
            var wrapperProps = {
                onClick: function () { return onClick(deal); }
            };
            if (shouldLinkToDealOnClick) {
                wrapperProps.id = id("link", _this.props);
                wrapperProps.styled = false;
                wrapperProps.to = "/info/" + deal.urlSlug;
                wrapperProps.app = apps.PERKS;
            }
            return {
                component: shouldLinkToDealOnClick ? StyledRouterLink : EmptyWrapper,
                props: wrapperProps
            };
        };
        return _this;
    }
    DealResult.prototype.render = function () {
        var _a = this.props, deal = _a.deal, badgeNumber = _a.badgeNumber, proximityMeters = _a.proximityMeters, locations = _a.locations, isMobile = _a.isMobile, shouldLinkToDealOnClick = _a.shouldLinkToDealOnClick, className = _a.className, showViewPerkDetailLink = _a.showViewPerkDetailLink, onViewPerkDetailClick = _a.onViewPerkDetailClick, branding = _a.branding;
        var apps = this.context.apps;
        var savings = get(deal.savings, "userSavings", {});
        var thumbnailImage = determineDealThumbnailImage(deal, branding);
        var savingHeader = deal.type === DEAL_TYPE_COMPANY_BENEFITS ? React.createElement(FormattedMessage, { id: "perks.companyBenefits.savings.saveLabel" }) : savings.header;
        var _b = this.getWrapper(), Wrapper = _b.component, wrapperProps = _b.props;
        var ProximityComponent = React.createElement(StyledProximity, { isMobile: isMobile, proximityMeters: proximityMeters, locations: locations });
        var ViewPerkDetailLinkComponent = (React.createElement(RouterLink, { app: apps.PERKS, to: "/info/" + deal.urlSlug, onClick: onViewPerkDetailClick },
            React.createElement(StyledIconText, { icon: "angleRight", iconPosition: "right" },
                React.createElement(FormattedMessage, { id: "platform.search.dealResult.viewPerkDetail.link.text" }))));
        return (React.createElement(Container, { isBoostedPerk: isBoostedPerk(deal), className: className, id: id("result", this.props), isDealUnavailable: isDealUnavailable(deal) },
            React.createElement(Wrapper, __assign({}, wrapperProps, { isDealUnavailable: isDealUnavailable(deal) }),
                React.createElement(Flex, { margin: "0 -4px" },
                    React.createElement(Flex, { flex: "1", marginRight: 1 },
                        React.createElement(AvatarContainer, null,
                            React.createElement(DealAvatar, { id: id("logo", this.props), src: thumbnailImage, small: true, withShadow: true }),
                            badgeNumber && React.createElement(StyledBadge, null, badgeNumber))),
                    React.createElement(Flex, { flex: "4", padding: "0", direction: isDealUnavailable(deal) ? "column" : "row" },
                        React.createElement(H5, { id: id("title", this.props), wordBreak: "break-word", marginBottom: 1 }, deal.header),
                        isDealUnavailable(deal) && React.createElement(UnavailableDeal, null),
                        !isDealUnavailable(deal) && proximityMeters && !isMobile && ProximityComponent),
                    !isDealUnavailable(deal) && (React.createElement(Flex, null,
                        isBoostedPerk(deal) && React.createElement(BoostedSaving, { value: savings.value }),
                        !isBoostedPerk(deal) && (React.createElement(SavingWrapper, { direction: "column", justifyContent: "space-between", height: "100%" },
                            React.createElement(Saving, { type: savings.type, header: savingHeader, saving: savings.value, currency: getCurrency(deal), smallSavingsHeader: true }),
                            showViewPerkDetailLink && !isMobile && ViewPerkDetailLinkComponent))))),
                !isDealUnavailable(deal) && isMobile && (proximityMeters || !shouldLinkToDealOnClick) && (React.createElement(SecondRow, null,
                    React.createElement(Col, null,
                        proximityMeters && ProximityComponent,
                        showViewPerkDetailLink && ViewPerkDetailLinkComponent))))));
    };
    DealResult.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    DealResult.defaultProps = {
        onClick: function () { },
        badgeNumber: null,
        proximityMeters: null,
        locations: null,
        shouldLinkToDealOnClick: true,
        className: null,
        showViewPerkDetailLink: false,
        onViewPerkDetailClick: function () { }
    };
    return DealResult;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({ isMobile: mq.lessThan.medium });
};
export default connect(mapStateToProps)(withBranding(DealResult));
